// export const baseApiUrl = '/api'
export const baseApiUrl = "https://www.nc-link.org.cn" ;
window.localStorage.setItem('baseApiUrl', baseApiUrl);